import type { CSSProperties, ReactNode, Ref } from 'react'

type DragGhostProps = {
    ghostRef: Ref<HTMLDivElement>
}

const base: CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'none',
    width: 0,
    height: 0,
    zIndex: 9999,
    pointerEvents: 'none',
    willChange: 'transform'
}

/**
 * Two stacked 1-px dotted outlines, black over white and offset by a pixel, so
 * the marquee stays visible over any wallpaper.
 */
export const DragGhost = ({ ghostRef }: DragGhostProps): ReactNode => {
    return (
        <div ref={ghostRef} style={base} aria-hidden='true'>
            <div className='absolute inset-0' style={{ outline: '1px dotted #000000', outlineOffset: 0 }} />
            <div className='absolute inset-0' style={{ outline: '1px dotted #ffffff', outlineOffset: '-1px' }} />
        </div>
    )
}
